import styled from 'styled-components';

export const Container = styled.div`
flex: 2.5;
background-color:var(--default-text-color);
padding:30px;
margin-right:30px;

@media(max-width:825px){
    display: none;
}
`
export const Wrapper = styled.div`
`
export const Title = styled.div`
font-style: normal;
font-weight: 600;
font-size: var(--font-size-primary);
line-height: 20px;
color: var(--common-dark-color);
margin-bottom: 30px;
`